import { useSearch } from "@tanstack/react-router";

export type ToolsSearchParams = {
  search: string;
  toolkits: string[];
  authProviders: string[];
  secrets: string[];
};

/**
 * Hook for reading tools search params from the URL.
 * Only used on the tools page.
 */
export function useToolsSearchParams(): ToolsSearchParams {
  return useSearch({
    from: "/_authenticated/orgs/$organizationId/projects/$projectId/tools",
    select: (params) => ({
      search: params.search || "",
      toolkits: params.toolkits || [],
      authProviders: params.authProviders || [],
      secrets: params.secrets || [],
    }),
    structuralSharing: true,
  });
}
